import { isParagraphBookmarkName } from "@common/utils/redline/ooxml/paragraph-bookmark-naming";

import { Citation } from "../types/chat";

const UNRESOLVED_MESSAGE_INDEX = -1;
const DOCUMENTS_PREFIX = "/documents/";
const DIOPTRA_PARAGRAPH_ID = /^_dioptra_p_[0-9a-f]+$/;

function isCitableParagraphId(bookmarkName: string): boolean {
  return DIOPTRA_PARAGRAPH_ID.test(bookmarkName) || isParagraphBookmarkName(bookmarkName);
}

export function focusedDocBookmarkRange(
  href: string,
  inFocusDocumentId: string | null,
): [string, string] | null {
  if (!inFocusDocumentId) return null;

  let url: URL;
  try {
    url = new URL(href, "https://dioptra.invalid");
  } catch {
    return null;
  }
  if (!url.pathname.startsWith(DOCUMENTS_PREFIX)) return null;
  if (url.searchParams.get("source") !== "conversation") return null;

  let documentId: string;
  try {
    documentId = decodeURIComponent(url.pathname.slice(DOCUMENTS_PREFIX.length));
  } catch {
    return null;
  }
  if (documentId !== inFocusDocumentId) return null;

  const start = url.searchParams.get("bookmark_start");
  const end = url.searchParams.get("bookmark_end");
  if (!start || !end) return null;
  if (!isCitableParagraphId(start) || !isCitableParagraphId(end)) return null;

  return [start, end];
}

export function extractCitationsFromContent(content: string): Citation[] {
  const bookmarkRegex = /\[(_dioptra_p_[a-f0-9]+(?:\s*,\s*_dioptra_p_[a-f0-9]+)*)\]/g;
  const citations: Citation[] = [];
  let match;
  let id = 1;

  while ((match = bookmarkRegex.exec(content)) !== null) {
    citations.push({
      id: id++,
      bookmarks: match[1].split(",").map((bookmark) => bookmark.trim()),
      messageIndex: UNRESOLVED_MESSAGE_INDEX,
    });
  }

  return citations;
}
